/**
 * Terminal mixin
 *
 * Добавляет логику для работы с терминалом
 *
 */

export default {
  staticData: () => ({
    terminalOperations: [],
    terminalTransactionId: '',
  }),
  computed: {
    paymentItems() {
      return []; // Данные о товарных позициях в чеке
    },
    paymentBeforeInfo() {
      return []; // Строчки в чеке до товарных позиций
    },
    paymentAfterInfo() {
      return []; // Строчки в чеке после товарных позиций
    },
    paymentCustomerInfo() {
      return ''; // Данные о покупателе для отправки чека (email или телефон)
    },
    paymentSum() {
      return 0; // Сумма оплаты (в рублях)
    },
    paymentTransactionId() {
      return this.terminalTransactionId; // ID транзакции эквайринга
    },
  },
  created() {
    this.initTerminalActions();
  },
  methods: {
    openTerminalSession() {
      this.setTerminalOperations([
        this.onTerminalSessionOpen,
      ]);
      return this.$robot.paymentTerminalService.openSession();
    },
    closeTerminalSession() {
      this.setTerminalOperations([
        this.onTerminalSessionClose,
      ]);
      return this.$robot.paymentTerminalService.reportZ();
    },
    startTerminalSaleProcess() {
      this.setTerminalOperations([
        this.startTerminalSale,
      ]);
      return this.checkTerminalHealth();
    },
    startTerminalRefundProcess() {
      this.setTerminalOperations([
        this.startTerminalRefund,
      ]);
      return this.checkTerminalHealth();
    },
    async checkTerminalHealth() {
      try {
        const [connected, error] = await Promise.all([
          this.$robot.paymentTerminalService.getConnected(),
          this.$robot.paymentTerminalService.getError(),
        ]);
        if (!connected || error !== 0) {
          throw error;
        }
        this.setTerminalOperations([
          this.onTerminalCheckComplete,
          ...this.terminalOperations,
        ]);
        this.startTerminalOperations();
      } catch (e) {
        this.showTerminalError(e, 'Terminal connected error');
      }
    },
    async startTerminalSale() {
      // Запускаем процесс оплаты
      const { sale, reason } = await this.$robot.paymentTerminalService.sale(
        this.paymentSum,
      );
      if (sale) {
        this.setTerminalOperations([
          this.onSaleComplete,
          this.startTerminalSaleRegistration,
        ]);
      } else {
        this.showTerminalError(1, reason);
        console.error('startTerminalSale', reason);
      }
    },
    async startTerminalSaleRegistration() {
      // Запускаем процесс регистрации покупки в ОФД
      const {
        registerSale,
        reason,
      } = await this.$robot.paymentTerminalService.registerSale(
        this.paymentItems,
        this.paymentBeforeInfo,
        this.paymentAfterInfo,
        this.paymentCustomerInfo,
      );
      if (registerSale) {
        this.setTerminalOperations([
          this.onSaleRegistrationComplete,
        ]);
      } else {
        console.error('startTerminalSaleRegistration', reason);
        this.startTerminalRefund();
      }
    },
    async startTerminalRefund() {
      // Запускаем процесс возврата покупки
      const { refund, reason } = await this.$robot.paymentTerminalService.refund(
        this.paymentSum,
        this.paymentTransactionId,
      );
      if (refund) {
        this.setTerminalOperations([
          this.onRefundComplete,
          this.startTerminalRefundRegistration,
        ]);
      } else {
        this.showTerminalError(1, reason);
        console.error('startTerminalRefund', reason);
      }
    },
    async startTerminalRefundRegistration() {
      // Запускаем процесс регистрации возврата в ОФД
      const {
        registerRefund,
        reason,
      } = await this.$robot.paymentTerminalService.registerRefund(
        this.paymentItems,
        this.paymentBeforeInfo,
        this.paymentAfterInfo,
        this.paymentCustomerInfo,
      );
      if (registerRefund) {
        this.setTerminalOperations([
          this.onRefundRegistrationComplete,
        ]);
      } else {
        this.showTerminalError(1, reason);
        console.error('startTerminalRefundRegistration', reason);
      }
    },
    async startTerminalOperations() {
      if (this.terminalOperations.length === 0) return;
      try {
        const operations = this.terminalOperations
          .filter((operation) => typeof operation === 'function')
          .map((operation) => operation());
        await Promise.all(operations);
      } catch (e) {
        console.error('startTerminalOperations', e);
      }
    },
    setTerminalPaperOut(paperAvailability) {
      if (paperAvailability) return;
      this.onTerminalPaperOut?.(); // eslint-disable-line
    },
    showTerminalError(code, message = '') {
      if (code === 0) return;
      this.setTerminalOperations([]);
      this.onTerminalError?.(code, message); // eslint-disable-line
      console.error('TerminalError: ', code, message);
    },
    setTerminalTransactionId(id) {
      this.terminalTransactionId = id;
    },
    setTerminalOperations(operations) {
      this.terminalOperations = operations;
    },
    initTerminalActions() {
      const robotActions = [
        this.$robot.paymentTerminalService.onPaperAvailability(this.setTerminalPaperOut),
        this.$robot.paymentTerminalService.onTransaction(this.setTerminalTransactionId),
        this.$robot.paymentTerminalService.onFinish(this.startTerminalOperations),
        this.$robot.paymentTerminalService.onError(this.showTerminalError),
      ];

      this.$once('hook:beforeDestroy', () => {
        robotActions.forEach((unsubscribe) => unsubscribe());
      });
    },
  },
};
